import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CmProAuthService } from '@app/core/services';
import { map, Observable, take } from 'rxjs';
import { UsersBus } from '../models/UsersBus.model';

export const UserLoadedResolver: ResolveFn<UsersBus> =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UsersBus> => {
        const authService = inject(CmProAuthService);
        return authService.userLoggedInEvent$.pipe(
            take(1),
            map(user => {
                return user;
            })
        );
    };
